import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class PreferredTimeZone extends Helper {
  @service clock;

  compute() {
    return this.clock.timeZone;
  }
}
